/**
 * futureReady.js — thin adapter from EXISTING learner events to the FutureReady evidence API. Fire-and-forget; never blocks
 * learning; the server decides whether the object is tagged/published and READY (Lesson Integrity). No careers anywhere.
 */
import { getChildId, learnerHeaders } from "@/lib/childId";
import { backendTier } from "@/lib/readiness";

const API = process.env.REACT_APP_BACKEND_URL;

const DEVICE_TIER = { little: "seedling", big: "explorer", older: "pioneer" };
const deviceTier = () => { try { return DEVICE_TIER[localStorage.getItem("we_age_group")] || "explorer"; } catch { return "explorer"; } };

export function emitFutureReadyEvent({ eventType, activityId, lessonId = null, assessmentId = null, subject = "", ageTier = null, source = "LESSON", score = null, total = null, metadata = {} }) {
  if (!activityId || typeof navigator !== "undefined" && navigator.onLine === false) return Promise.resolve(null);
  try { if (sessionStorage.getItem("mwq_airline_session") === "1" || localStorage.getItem("mwq_runtime_profile") === "AIRLINE_EVALUATION") return Promise.resolve(null); } catch { /* ignore */ } // anonymous shared session: no learner evidence leaves the device
  ageTier = ageTier || deviceTier();
  return fetch(`${API}/api/futureready/evidence`, {
    method: "POST", headers: learnerHeaders(),
    body: JSON.stringify({ learnerId: getChildId(), eventType, activityId, lessonId, assessmentId, subject: String(subject || "").toLowerCase(), ageTier: backendTier(ageTier), source, score, total, metadata }),
  }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
}

export const fetchPassport = (learnerId = getChildId()) => fetch(`${API}/api/futureready/learner/${encodeURIComponent(learnerId)}/passport`, { headers: learnerHeaders() }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
export const fetchSchoolSummary = () => fetch(`${API}/api/futureready/school/summary`).then((r) => (r.ok ? r.json() : null)).catch(() => null);

export const STATUS_LABEL = { INSUFFICIENT: "Insufficient evidence", EMERGING: "Emerging", DEVELOPING: "Developing", DEMONSTRATED: "Demonstrated" };
export const STATUS_TONE = { INSUFFICIENT: "bg-slate-100", EMERGING: "bg-sky-100", DEVELOPING: "bg-amber-100", DEMONSTRATED: "bg-emerald-100" };
